var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM5.19301 6.12495C4.93566 5.8676 4.93566 5.45036 5.19301 5.19301C5.45036 4.93566 5.8676 4.93566 6.12495 5.19301L10 9.06806L13.8751 5.19301C14.1324 4.93566 14.5496 4.93566 14.807 5.19301C15.0643 5.45036 15.0643 5.8676 14.807 6.12495L10.9319 10L14.807 13.8751C15.0643 14.1324 15.0643 14.5496 14.807 14.807C14.5496 15.0643 14.1324 15.0643 13.8751 14.807L10 10.9319L6.12495 14.807C5.8676 15.0643 5.45036 15.0643 5.19301 14.807C4.93566 14.5496 4.93566 14.1324 5.19301 13.8751L9.06806 10L5.19301 6.12495Z",
    fill: "#F4F1EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.766599a6cff7561dae7aed3d8be9359c.svg";
export { ForwardRef as ReactComponent };